export const preferenceKey = (user, network) => `production-scheduling:v1:${user}:${network}`;

export function groupJobs(rows, kind, pinned = [], order = [], includeDone = false) {
  const groups = new Map(pinned.map(r => [String(r.id), {...r, items: [], allItems: [], pinned: true}]));
  rows.forEach(row => {
    const id = row[`${kind}_id`];
    if (!id) return;
    const key = String(id);
    if (!groups.has(key)) groups.set(key, {id, name: row[kind], items: [], allItems: []});
    const group = groups.get(key);
    group.name = row[kind] || group.name;
    group.allItems.push(row);
    if (includeDone || row.status !== 'DONE') group.items.push(row);
  });
  const rank = id => { const n = order.map(String).indexOf(String(id)); return n < 0 ? Number.MAX_SAFE_INTEGER : n; };
  return [...groups.values()].filter(g => g.pinned || g.items.length).sort((a, b) => rank(a.id) - rank(b.id) || (a.name || '').localeCompare(b.name || ''));
}

export function utilization(rows, kind, date) {
  const shifts = new Map();
  rows.filter(r => (r.scheduled_from || '').slice(0, 10) === date).forEach(r => {
    const key = r.schedule_id || `unknown-${date}`;
    if (!shifts.has(key)) shifts.set(key, {name: r.shift_name, planned: 0, available: null, missing: false});
    const shift = shifts.get(key);
    shift.planned += Number(r.standard_minutes || 0);
    shift.missing ||= r.standard_minutes == null;
    const available = kind === 'subcontractor' ? null : kind === 'employee' ? r.employee_capacity_minutes : r.capacity_minutes;
    if (available != null) shift.available = Math.max(shift.available || 0, available);
  });
  return [...shifts.values()];
}
